import React, { useCallback, useState, useEffect } from 'react';
import { Button } from 'antd';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';
import { useOrganization } from '@components/OrganizationBoundary';
import isTrialEnd from '@helpers/isTrialEnd';
import { ContributorsLimitErrorNotificationIcon, CrossIcon } from '@icons';

function ExtraStorageSizeAlert({
  fullScreen = false
}: {
  fullScreen?: boolean;
}) {
  const navigate = useNavigate();
  const { currentOrganization } = useOrganization(true);
  const [isAlertVisible, setIsAlertVisible] = useState<boolean>(false);

  useEffect(() => {
    if (!currentOrganization.entity) return;

    const result = isTrialEnd(currentOrganization.entity);
    if (result) return;

    if (
      !currentOrganization.entity.lockReasons.includes(
        'asset-summary-size-limit-exceeded'
      )
    )
      return;

    setIsAlertVisible(true);
  }, [currentOrganization]);
  const storageSizeLimit = useCallback(() => {
    return currentOrganization.entity?.limitsV2.fileSize;
  }, [currentOrganization])();

  if (!isAlertVisible) return null;
  return (
    <div
      className={classNames(
        'alert-container',
        fullScreen && 'alert-container-full-screen'
      )}
    >
      <div className="info">
        <div className="icon">
          <ContributorsLimitErrorNotificationIcon />
        </div>
        <div className="copies">
          <span className="title">
            You&apos;ve exceeded your allotted storage
          </span>
          <span className="description">
            Your plan includes {storageSizeLimit}GB storage. Upgrade your plan
            or remove creative media to free up storage.
          </span>
        </div>
      </div>
      <div className="actions">
        <Button
          type="primary"
          onClick={() => {
            setIsAlertVisible(false);
            navigate('/assets/all');
          }}
        >
          Delete storage
        </Button>
        <CrossIcon
          style={{ cursor: 'pointer' }}
          onClick={() => setIsAlertVisible(false)}
        />
      </div>
    </div>
  );
}

export default ExtraStorageSizeAlert;
